<template>
    <div class="thankyou-view view" :style="bodyStyles">
        <div class="wrapper">
            <div class="splash-logo">
                <a href="/">
                    <img src="../../less/img/logo.png" />
                </a>
            </div>

            <h2 class="h2" v-html="ui.texts.thankyouText.title"></h2>

            <div class="highlight-text">
                <div class="text" v-html="ui.texts.thankyouText.text"></div>
            </div>

            <label class="form-group highlights">
                <div class="image-group">
                    <a :href="highlight.link" class="list-group-item col-6" v-for="highlight in ui.blocks.thankyouHighlights" :key="highlight">
                        <div class="container">
                            <div class="image" :style="{ 'background-image': ui.getBackgroundImageUrl(highlight.images[0], 600)! }"></div>

                            <h3>
                                {{ highlight.title }}
                            </h3>
                        </div>
                    </a>
                </div>
            </label>
        </div>

        <div class="navigation">
            <div class="wrapper">
                <router-link to="/summary" v-html="ui.t('previous')" />
            </div>
        </div>
    </div>
</template>

<script async setup lang="ts">
import { computed } from 'vue';
import { useUI } from '../store';

const { ui } = useUI();

const bodyStyles = computed(() => {
    return {
        "background-image": "url('" + ui.texts.thankyouText.images[0] + "')"
    }
});

</script>
